
import React, { useState } from "react";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { RegisterFormValues } from "@/types/auth";
import { Eye, EyeOff } from "lucide-react";

interface PasswordFieldsProps {
  form: UseFormReturn<RegisterFormValues>;
}

export const PasswordFields = ({ form }: PasswordFieldsProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <>
      <FormField
        control={form.control}
        name="password1"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-black">Password</FormLabel>
            <div className="relative">
              <FormControl>
                <Input 
                  type={showPassword ? "text" : "password"} 
                  placeholder="Enter Password" 
                  {...field} 
                  className="bg-white border-gray-200"
                />
              </FormControl>
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="password2"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-black">Confirm Password</FormLabel>
            <div className="relative">
              <FormControl>
                <Input 
                  type={showConfirmPassword ? "text" : "password"} 
                  placeholder="Re-enter Password" 
                  {...field} 
                  className="bg-white border-gray-200"
                />
              </FormControl>
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
              >
                {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
